import React, { useEffect, useRef, useCallback } from "react";

const DEBOUNCE_DELAY = 20000;

const useDebouncedInterval = (callback, delay) => {
	const savedCallback = useRef();

	useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	useEffect(() => {
		function tick() {
			savedCallback.current?.();
		}
		if (delay !== null) {
			const id = setInterval(tick, delay);
			tick(); // appel immédiat
			return () => clearInterval(id);
		}
	}, [delay]);
};

const useLoadingSafeCall = () => {
	const isFetching = useRef({
		openedFolders: false,
		tubes: false,
		aliquots: false,
		assignedHelp: false,
	});

	const getWithLoading = useCallback(async (key, fetchFn, setLoading, isLoading) => {
		if (isFetching.current[key] || isLoading) return;

		isFetching.current[key] = true;
		setLoading(true);
		try {
			await fetchFn();
		} finally {
			setLoading(false);
			isFetching.current[key] = false;
		}
	}, []);

	return getWithLoading;
};

const RepetitiveCalls = ({ getMyOpenedFolders, getFoldersWaitingTubes, getFoldersWaitingAliquots, getAssignedToMeFolderHelp, center, inCenter }) => {
	const [openedFoldersLoading, setOpenedFoldersLoading] = React.useState(false);
	const [tubesLoading, setTubesLoading] = React.useState(false);
	const [aliquotsLoading, setAliquotsLoading] = React.useState(false);
	const [assignedToMeFolderHelpLoading, setAssignedToMeFolderHelpLoading] = React.useState(false);

	const safeCall = useLoadingSafeCall();

	const fetchInfos = useCallback(() => {
		safeCall("openedFolders", getMyOpenedFolders, setOpenedFoldersLoading, openedFoldersLoading);
		safeCall("tubes", getFoldersWaitingTubes, setTubesLoading, tubesLoading);

		if (getFoldersWaitingAliquots) {
			safeCall("aliquots", () => getFoldersWaitingAliquots(center.id), setAliquotsLoading, aliquotsLoading);
		}
		if (getAssignedToMeFolderHelp) {
			safeCall("assignedHelp", () => getAssignedToMeFolderHelp(inCenter), setAssignedToMeFolderHelpLoading, assignedToMeFolderHelpLoading);
		}
	}, [
		safeCall,
		getMyOpenedFolders,
		getFoldersWaitingTubes,
		getFoldersWaitingAliquots,
		getAssignedToMeFolderHelp,
		center.id,
		inCenter,
		openedFoldersLoading,
		tubesLoading,
		aliquotsLoading,
		assignedToMeFolderHelpLoading,
	]);

	useDebouncedInterval(fetchInfos, DEBOUNCE_DELAY);

	return null;
};

RepetitiveCalls.displayName = "RepetitiveCalls";

export default RepetitiveCalls;
